import $ from 'jquery';

function initControl(el, observe, not) {
	observe = $(observe).get(0);
	var radioList = $(observe.form.elements[observe.name]);

	function update() {
		var isSelected = not ? observe.checked : !observe.checked;

		el.hidden = isSelected;

		if ($(el).hasClass('i-required-box')) {
			setRequired(!isSelected, el);
		}	
	}

	radioList.on('change', update);
	update();
}

function initSelect(el, observe, not) {
	observe = $(observe).get(0);

	var select = $(observe.form).find(observe).closest('select');
	
	function update() {
		var isSelected = not ? observe.selected : !observe.selected;

		el.hidden = isSelected;
		
		setRequired(!isSelected, el);
	}

	select.on('change', update);

	update();
}

function setRequired(val, el){
	var input = $(el).find('input');
	input.each(function(i, el) {
		el.required = val;
	});
}

$.addInit(function(context){
	$('[data-if]', context).each(function(){
		initControl(this, $(this).data('if'), false);
	});

	$('[data-if-not]', context).each(function(){
		initControl(this, $(this).data('if-not'), true);
	});

	$('[data-select-if]').each(function(){
		initSelect(this, $(this).data('select-if'), false);
	});
});
